import layout from './layouts/Main.vue'
import BaseGestaoMixin from '@/app/shared/mixins/BaseGestaoMixin';
import ModuleMixin from './shared/mixins/ModuleMixin';
import ManageStoreMixin from './shared/mixins/ManageStoreMixin';

export default {
    mixins: [
        BaseGestaoMixin,
        ModuleMixin,
        ManageStoreMixin,
    ],
	components: {
	    layoutGestao: layout,
	},
    data() {
        return {

        }
    },
    computed: {
    },
    methods: {
        print: function()
		{
			javascript:window.print()
		}
    },
}
